import { useEffect, useState } from 'react';
import { GridInitialState } from '@mui/x-data-grid-pro';
import { LinkEvent, fetchLinkEvents, getCruxLinkEventsSubject } from '../../../../../store/LinkEvent';
import { ApiAdvancedFilter, PaginatedResponse } from '../../../../../store/GeneralStore';
import { DefaultLinkEventGridColumnDefs } from '../../ColumnDefs/LinkEventGridColumnDefs';
import { UpstackDataGrid } from '../../../../Compounds/UpstackDataGrid/UpstackDataGrid';
import {
  getCustomizationSubject,
  getDefaultPreferences,
  GridPreferences
} from '../../../../../store/UserCustomizations';
import { getInitialState } from '../../../../Compounds/UpstackDataGrid/helpers';
import { ComponentSpinner } from '../../../../Compounds/Loading/ComponentSpinner';
import { PageLayout } from '../../../../PageLayout';

export const LogTab = () => {
  const [linkEventsLoading, setLinkEventsLoading] = useState<boolean>(false);
  const [linkEvents, setLinkEvents] = useState<PaginatedResponse<LinkEvent>>();
  const [gridSettings, setGridSettings] = useState<GridPreferences>(
    getDefaultPreferences()?.content['linkEventGrid'] as GridPreferences
  );
  const [initialState, setInitialState] = useState<GridInitialState>();
  const filterKeys = DefaultLinkEventGridColumnDefs.filter((column) => column.filterable).map((column) => column.field);

  const handleFetchLinkEvents = async (filters?: ApiAdvancedFilter, localLoading?: boolean, forceRefresh = false) => {
    if (localLoading) setLinkEventsLoading(true);
    await fetchLinkEvents(filters, forceRefresh);
    if (localLoading) setLinkEventsLoading(false);
  };

  useEffect(() => {
    const linkEventsSub = getCruxLinkEventsSubject().subscribe((linkEvents) => setLinkEvents(linkEvents));
    const userCustSub = getCustomizationSubject().subscribe((userCust) => {
      if (userCust) {
        setGridSettings(userCust.content.linkEventGrid);

        const state = getInitialState(userCust.content.linkEventGrid, DefaultLinkEventGridColumnDefs, 'linkEventGrid');
        setInitialState(state);

        const savedSort = state.sorting?.sortModel;
        const initialSortModel = savedSort?.length ? savedSort : undefined;
        handleFetchLinkEvents(
          {
            orders: initialSortModel
              ? initialSortModel.map((sort) => ({ sort: sort.field, direction: sort.sort }))
              : undefined
          },
          true
        );
      }
    });

    return () => {
      if (linkEventsSub) linkEventsSub.unsubscribe();
      if (userCustSub) userCustSub.unsubscribe();
    };
  }, []);

  return (
    <PageLayout
      className="w-full"
      dataTestId="log-page"
      dataCy="log-page-card"
      pageTitle="">
      <div data-testid="link-event-management">
        <>
          {!initialState ||
            (linkEventsLoading && (
              <div className="flex h-[45rem] m-auto">
                <ComponentSpinner label="Loading data..." />
              </div>
            ))}
          {initialState && !linkEventsLoading && (
            <UpstackDataGrid
              title="Log"
              rows={linkEvents?.data || []}
              columns={DefaultLinkEventGridColumnDefs}
              page="linkEventGrid"
              gridSettings={gridSettings}
              showSearch={false}
              apiFilter={true}
              fetchFunction={handleFetchLinkEvents}
              filterKeys={filterKeys}
              rowCount={linkEvents?.totalCount}
              advancedFiltering={true}
              initialState={initialState}
            />
          )}
        </>
      </div>
    </PageLayout>
  );
};
